// CimavetSVG.jsx
import React from 'react';

const CimavetSVG = ({ fill, width, height }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width} // Aquí se usan las props
      height={height} // Aquí se usan las props
      viewBox="0 0 783.000000 182.000000"
      preserveAspectRatio="xMidYMid meet"
      fill={fill} // Usando la prop 'fill'
    >
      {/* Contenido de tus paths SVG */}
      <metadata>
      Created by potrace 1.16, written by Peter Selinger 2001-2019
      </metadata>
      <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
      stroke="none">
      <path d="M1609 1800 c-116 -61 -143 -208 -56 -307 41 -47 82 -63 159 -63 112
      1 189 57 206 151 25 134 -68 240 -209 239 -43 -1 -76 -7 -100 -20z"/>
      <path d="M575 1465 c-152 -34 -252 -90 -365 -204 -71 -71 -94 -102 -132 -181
      -26 -52 -54 -125 -62 -161 -23 -93 -21 -266 3 -361 61 -236 231 -423 464 -511
      71 -26 98 -31 210 -35 156 -5 230 10 365 74 71 35 109 61 163 113 38 38 69 75
      69 83 0 8 -65 68 -145 132 l-146 117 -38 -31 c-111 -87 -260 -115 -364 -67
      -77 35 -132 88 -169 165 -29 58 -33 76 -33 147 0 66 5 90 26 136 70 150 211
      224 360 189 30 -7 89 -30 131 -52 42 -22 83 -38 91 -36 25 6 307 193 307 203
      0 16 -113 130 -165 165 -160 110 -387 156 -570 115z"/>
      <path d="M2392 1460 c-169 -44 -329 -174 -374 -300 -9 -28 -7 -34 25 -70 76
      -83 72 -50 75 -592 l3 -488 174 0 175 0 0 549 0 548 44 6 c87 12 161 -26 199
      -102 22 -45 22 -52 25 -523 l3 -478 169 0 170 0 0 544 c0 603 -7 545 63 560
      73 17 174 -50 196 -129 7 -27 11 -197 11 -507 l0 -468 175 0 175 0 0 513 c0
      570 -1 582 -65 688 -45 72 -140 161 -213 198 -109 54 -158 66 -282 66 -105 0
      -124 -3 -211 -33 -93 -33 -97 -33 -128 -17 -104 53 -281 68 -409 35z"/>
      <path d="M4265 1461 c-221 -63 -395 -274 -395 -478 l0 -53 169 0 168 0 18 45
      c36 95 95 138 186 138 83 -1 133 -33 175 -113 18 -33 19 -69 22 -512 l3 -478
      169 0 170 0 0 508 c0 560 -1 574 -62 681 -48 85 -153 183 -240 224 -40 19 -97
      40 -126 46 -76 16 -187 12 -257 -8z"/>
      <path d="M7300 808 c0 -555 2 -596 19 -634 27 -59 77 -111 135 -142 48 -25 60
      -27 214 -30 l162 -4 0 151 0 151 -108 0 c-71 0 -112 4 -120 12 -9 9 -12 83
      -12 270 l0 258 120 0 120 0 0 140 0 140 -120 0 -120 0 0 140 0 140 -145 0
      -145 0 0 -592z"/>
      <path d="M1500 655 l0 -645 200 0 200 0 0 645 0 645 -200 0 -200 0 0 -645z"/>
      <path d="M5100 1117 c0 -13 144 -484 247 -807 65 -207 81 -240 130 -277 34
      -26 43 -28 129 -28 89 0 94 1 124 30 18 17 40 46 50 66 19 37 330 996 330
      1017 0 9 -47 12 -167 12 l-168 0 -85 -339 -85 -339 -13 41 c-18 60 -117 456
      -138 555 l-17 82 -169 0 c-131 0 -168 -3 -168 -13z"/>
      <path d="M6510 1111 c-189 -60 -337 -213 -385 -398 -19 -73 -19 -222 0 -293
      53 -199 229 -370 422 -410 88 -19 244 -8 324 22 124 46 244 151 301 262 33 64
      58 146 58 188 l0 38 -144 0 -145 0 -27 -61 c-17 -36 -43 -74 -67 -94 -71 -61
      -178 -82 -254 -50 l-37 16 27 22 c232 190 576 485 576 495 1 23 -56 98 -111
      147 -60 52 -149 99 -228 120 -77 21 -241 19 -310 -4z m233 -289 c14 -6 -18
      -37 -158 -155 l-175 -147 0 46 c0 69 19 120 64 171 52 60 123 93 196 92 30 0
      63 -4 73 -7z"/>
      <path d="M4123 650 c-94 -20 -180 -87 -224 -176 -21 -42 -24 -63 -24 -149 0
      -89 3 -106 27 -150 57 -108 139 -157 274 -163 116 -5 174 12 242 73 72 65 97
      127 97 240 0 78 -4 97 -28 147 -65 132 -220 208 -364 178z"/>
      </g>
    </svg>
  );
};

export default CimavetSVG;